import { render, staticRenderFns } from "./TabSwitcher.vue?vue&type=template&id=50e8a413&scoped=true&"
import script from "./TabSwitcher.vue?vue&type=script&lang=js&"
export * from "./TabSwitcher.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50e8a413",
  null
  
)

export default component.exports